<template lang="pug">
    v-container(grid-list-lg)
        v-layout(raw wrap)
            v-flex(xs12 md10 offset-md1)
                layout.contentTransparent(class="v-cloak")

                    // View session
                    view-session(v-if="session.title" :session="session" :duration="duration" ref="sessionView" :isLoading="loading")

                    // Similar meditations list
                    sessions-list-component(v-if="session.id" :session="session" :title="$t('sessions.view.listTitle')")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ViewSession from './ViewSession';
    import SessionsList from '~components/SessionsList';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';

    export default {
        components: {
            Layout,
            ViewSession,
            SessionsListComponent: SessionsList,
            TitleComponent: Title
        },
        props: {
            id: VueTypes.string.def(''),
            duration: VueTypes.number.def(0)
        },
        data() {
            return {
                loading: true
            };
        },
        watch: {
            async id(val, oldVal) {
                if (oldVal && oldVal !== val) {
                    await this.resetSession();
                    await this.read({ id: this.id });
                    this.validToShowMood();
                }
            }
        },
        computed: {
            ...mapFields('sessions', ['session']),
            ...mapGetters('sessions', ['isVoted', 'moodBefore']),
            ...mapGetters('auth', [
                'isMember',
                'isChampion',
                'isAdmin',
                'isInstructor',
                'user'
            ])
        },
        async beforeRouteLeave(to, from, next) {
            if (this.isAdmin || this.isInstructor || this.isVoted)
                return next();
            const resp = await this.$refs.sessionView.checkLeaveRoute();
            if (resp) return next();
            return next(false);
        },
        async created() {
            await this.read({ id: this.id });

            this.loading = false;

            this.validToShowMood();
        },
        beforeDestroy() {
            this.resetSession();
        },
        methods: {
            ...mapActions('sessions', [
                'read',
                'setShowMood',
                'setBackLink',
                'resetSession'
            ]),

            validToShowMood() {
                if (
                    (this.isMember || this.isChampion) &&
                    !this.isVoted &&
                    !this.moodBefore
                ) {
                    this.setShowMood();
                }
            }
        }
    };
</script>

<style lang="stylus">
    .title
        margin-bottom: 15px
</style>
